import { auth } from '@/config/firebase'

export async function getTokenClient() {
  // auth.onAuthStateChanged(async (e) => {
  //     const token = await e?.getIdToken();
  //     if (token) {
  //         RefeshAction(token);
  //     }
  // });

  const token = await auth.currentUser?.getIdToken()

  // const token = await getTokenUser();

  return token
}
